<script setup>
const props = defineProps({
  // all search filters
  modelValue: {
    type: Object,
    default: () => ({}),
  },

  withBack: {
    type: Boolean,
    default: false,
  },
  isFlowFinish: {
    type: Boolean,
    default: false,
  },
  isFlowRunning: {
    type: Boolean,
    default: false,
  },
  modelUpdateMode: {
    type: String,
    default: 'change',
    validator: (value) => ['change', 'submit'].includes(value),
  },
});

const emit = defineEmits(['close', 'back', 'success', 'update:modelValue']);

const modelData = ref(cloneObject(props.modelValue));
const modelValueLocal = computed({
  get() {
    return modelData.value;
  },
  set(value) {
    modelData.value = value;

    if (props.modelUpdateMode === 'change') {
      emit('update:modelValue', value);
    }
  },
});

function handleSubmit() {
  if (props.modelUpdateMode === 'submit') {
    emit('update:modelValue', modelValueLocal.value);
  }

  emit('success');
}
</script>

<template>
  <FormsSearchScreenWrapper
    class="forms-search-screens-seats"
    :name="$t('form.seats')"
    :departure-name="modelData.departureStation?.name"
    :arrival-name="modelData.arrivalStation?.name"
    :with-back="withBack"
    @close="emit('close')"
    @back="emit('back')"
  >
    <div class="forms-search-screens-seats__container">
      <BundlesSeatsSelect
        v-model="modelValueLocal"
        :is-flow-finish="isFlowFinish"
        :is-flow-running="isFlowRunning"
        class="forms-search-screens-seats__select"
        @success="handleSubmit"
      />
    </div>
  </FormsSearchScreenWrapper>
</template>

<style scoped lang="scss">
.forms-search-screens-seats {
  &__container {
    display: flex;
    flex-grow: 1;
    flex-direction: column;
    padding: em(5) em(16) 0;
    overflow: hidden auto;
  }

  &__select {
    flex-grow: 1;
  }
}
</style>
